import routes from "../../../../../core/services/common/api-routes"
import {HttpAuthGet, HttpAuthPost, HttpAuthPut, HttpAuthDelete, HttpAuthPutParamsPayload} from "../../../../../core/services/common/HttpRequestBuilder"

const listModules = () => {

    let result = HttpAuthGet(routes.LIST_MODULE, null);
    return result;
}

const createModule = (payload) => {

    let result = HttpAuthPost(routes.CREATE_MODULE, payload);
    return result;
}

const updateModule = (parameters, payload) => {

    let result = HttpAuthPutParamsPayload(routes.UPDATE_MODULE, parameters, payload);
    return result;
}


const deleteModule = (parameters) => {

    let result = HttpAuthDelete(routes.DELETE_MODULE, parameters);
    return result;
}

const ModuleService = {
    createModule,
    updateModule,
    deleteModule,
    listModules
}

export default ModuleService
